<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,1C3,0.45,2.55,0,2,0C1.45,0,1,0.45,1,1C1,1,1,4,1,4C1,4,3,4,3,4C3,4,3,1,3,1C3,1,3,1,3,1ZM3,5C3,5,1,5,1,5C0.45,5,0,5.45,0,6C0,6,0,8,0,8C0,8.55,0.45,9,1,9C1,9,3,9,3,9C3.55,9,4,8.55,4,8C4,8,4,6,4,6C4,5.45,3.55,5,3,5C3,5,3,5,3,5ZM15,1C15,0.45,14.55,0,14,0C13.45,0,13,0.45,13,1C13,1,13,3,13,3C13,3,15,3,15,3C15,3,15,1,15,1C15,1,15,1,15,1ZM9,1C9,0.45,8.55,0,8,0C7.45,0,7,0.45,7,1C7,1,7,7,7,7C7,7,9,7,9,7C9,7,9,1,9,1C9,1,9,1,9,1ZM1,15C1,15.55,1.45,16,2,16C2.55,16,3,15.55,3,15C3,15,3,10,3,10C3,10,1,10,1,10C1,10,1,15,1,15C1,15,1,15,1,15ZM15,4C15,4,13,4,13,4C12.45,4,12,4.45,12,5C12,5,12,7,12,7C12,7.55,12.45,8,13,8C13,8,15,8,15,8C15.55,8,16,7.55,16,7C16,7,16,5,16,5C16,4.45,15.55,4,15,4C15,4,15,4,15,4ZM13,15C13,15.55,13.45,16,14,16C14.55,16,15,15.55,15,15C15,15,15,9,15,9C15,9,13,9,13,9C13,9,13,15,13,15C13,15,13,15,13,15ZM9,8C9,8,7,8,7,8C6.45,8,6,8.45,6,9C6,9,6,11,6,11C6,11.55,6.45,12,7,12C7,12,9,12,9,12C9.55,12,10,11.55,10,11C10,11,10,9,10,9C10,8.45,9.55,8,9,8C9,8,9,8,9,8ZM7,15C7,15.55,7.45,16,8,16C8.55,16,9,15.55,9,15C9,15,9,13,9,13C9,13,7,13,7,13C7,13,7,15,7,15C7,15,7,15,7,15Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Settings',
} as DefineComponent
</script>
